import { buildWhatsAppLink } from "@/lib/whatsapp";

export const FinalCTA = () => {
  return (
    <section
      id="cta-final"
      data-testid="cta-final-section"
      className="bg-[#f5f3f0] py-32 md:py-44 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grain opacity-50 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-4xl reveal">
          <div className="flex items-center gap-4 mb-10">
            <span className="rule-yellow" />
            <span className="eyebrow">Próximas turmas · Edição 2026</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl lg:text-[4.2rem] leading-[1.04] tracking-tight text-[#0a0a0a]">
            Faça parte da nova geração de profissionais da beleza.
          </h2>
          <p className="mt-10 text-lg md:text-xl leading-relaxed text-[#1f1f1f] max-w-2xl">
            Entre para a próxima formação da Oasys Academy e aprenda a crescer
            com mais método, clareza e direção.
          </p>

          <div className="mt-14 flex flex-wrap items-center gap-8">
            <a
              href={buildWhatsAppLink(
                "Olá! Quero conhecer as próximas turmas da Oasys Academy.",
              )}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-final-button"
              className="btn-primary"
            >
              Quero conhecer as próximas turmas
              <span aria-hidden>→</span>
            </a>
            <a
              href="#formacoes"
              data-testid="cta-final-secondary"
              className="text-link-arrow"
            >
              Ver formações
              <span aria-hidden className="arrow">
                →
              </span>
            </a>
          </div>

          <div className="mt-20 pt-10 border-t border-[#0a0a0a]/15 flex flex-col md:flex-row gap-8 md:gap-16">
            <div>
              <p className="eyebrow text-[#6b6b6b]">Direção</p>
              <p className="font-display text-xl mt-3 text-[#0a0a0a]">
                Gilson Ribeiro
              </p>
            </div>
            <div>
              <p className="eyebrow text-[#6b6b6b]">Sede</p>
              <p className="font-display text-xl mt-3 text-[#0a0a0a]">
                Oasys Hair
              </p>
            </div>
            <div>
              <p className="eyebrow text-[#6b6b6b]">Edição</p>
              <p className="font-display text-xl mt-3 text-[#0a0a0a]">
                Oasys Academy 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
